<!--
    描述：人员管理--右侧组织架构
    时间：2020-04-22
    Created by zwh
-->
<template>
    <div class="h100">
        <div class="w-table-layout">
            <div class="w-table-content" ref="menusContent">
                <el-tree :data="menusTreeData.treeData" :props="defaultProps" @node-click="handleNodeClick" :expand-on-click-node="false" :highlight-current="true" default-expand-all></el-tree>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import {selectTree} from 'api/system/menu.js'

    export default {
        components: {},
        data() {
            return {
                btnLoading: false,
                //弹框对象
                dialogObj: {
                    title: '',
                    visible: false,
                    width: '650px',
                    mode: 'add',
                },
                //树对象
                menusTreeData: {
                    loading: false,
                    tableH: 200,
                    treeData: []
                },
                //树props
                defaultProps: {
                    children: 'children',
                    label: 'sname'
                },
                //点击节点
                clickNode : {
                    id : '',
                    sname : '',
                },

            }
        },
        methods: {
            //获取菜单信息
            getTreeData(){
                let param = {};
                selectTree(param).then(res => {
                    this.menusTreeData.treeData = res.data;
                });
            },
            //点击节点
            handleNodeClick(e){
                this.clickNode.id = e.id
                this.clickNode.sname = e.sname

                this.$emit('handle-select-parent-menu', this.clickNode)
            },
        },
        created() {
            //获取菜单信息
            this.getTreeData();
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight;
                }, 100)
            })
        },
        computed: {
            ...mapState('app', {clientSize: state => state.clientSize})
        },
        watch: {
            clientSize(val) {
                this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight;
            }
        }
    }
</script>
<style lang="less">

</style>
